import React from "react";
import error from "../../assests/error.png";

const Error = () => {
  return <img src={error} alt="404" />;
};

export default Error;
